import React, { useState } from "react";
import "./buttonGroup.css";

const ButtonGroup = ({ buttonNames, onButtonSelect }) => {
  const [selected, setSelected] = useState(buttonNames[0]);

  const handleButtonClick = (value) => {
    setSelected(value);
    onButtonSelect(value); // Call the callback with the selected button name
  };

  return (
    <div className="button-group-container">
      <div className="button-group">
        {buttonNames.map((name, index) => (
          <button
            key={index}
            className={`button-text ${selected === name ? "active" : ""}`}
            onClick={() => handleButtonClick(name)}
          >
            {name}
          </button>
        ))}
      </div>
      <hr className="underline" />
    </div>
  );
};

export default ButtonGroup;
